import * as React from 'react';

import classnames from 'classnames';

import styles from './modal-title.module.css';

type Props = {
    children?: React.ReactNode;
    as: string;
    lessBottomMargin?: boolean;
};

ModalTitle.defaultProps = {
    as: 'div',
    lessBottomMargin: false,
};

export function ModalTitle({children, as: Tag, lessBottomMargin}: Props) {
    const styleName = classnames(styles['modal-title'], {
        [styles['modal-title--less-bottom-margin']]: lessBottomMargin,
    });

    // @ts-expect-error
    return <Tag className={styleName}>{children}</Tag>;
}
